import type { ClientCustomerType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import type { NewObjectType } from 'modules/lead';
import type { NewSaleType } from 'modules/objects';
import { type ClientCustomerActionClient } from '../ClientCustomerAction';
import ClientCustomersTableRow from './ClientCustomersTableRow';

interface ClientCustomersTableBodyProps {
    rows: ClientCustomerType[];
    onEdit: (row: ClientCustomerType) => void;
    onDelete: (row: ClientCustomerType) => void;
    onCreateSale?: (sale: NewSaleType) => void;
    onCreateObject?: (object: NewObjectType) => void;
    client?: ClientCustomerActionClient;
}

const ClientCustomersTableBody = ({
    rows,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
    client,
}: ClientCustomersTableBodyProps) => {
    return (
        <tbody>
            {!rows.length ? (
                <TableEmptyRow colSpan={4} />
            ) : (
                rows.map((row) => (
                    <ClientCustomersTableRow
                        key={row.ID}
                        row={row}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onCreateSale={onCreateSale}
                        onCreateObject={onCreateObject}
                        client={client}
                    />
                ))
            )}
        </tbody>
    );
};

export default ClientCustomersTableBody;
